import requests from "./api/base-api";

const FileService = {
    uploadFile: (formData) => requests.postFormData(`/file/v1/upload`, formData),
};

export default FileService;